export interface FileMatch {
  field: ColumnKey | null;
  matched: boolean;
  matchedBy: string;
  columnIndex: number | null;
  columnHeader: string;
  required: boolean;
  recommended: boolean;
  values: string[];
  groupMatches?: FileMatches;
  errorType?: 'format' | 'duplicate';
  errorMsg?: string;
}

export type FileMatches = FileMatch[];

export interface NormalizeFile {
  filename?: string;
  headers: string[];
  rows: string[][] | null;
}

export interface ColumnMatchField {
  key: string;
  labels: string[];
  required: boolean;
  recommended: boolean;
  valueRegex?: RegExp[];
  allowedValues?: string[];
}

export enum ChipIconType {
  MATCHED = 'matched',
  SYSTEM_MATCHED = 'system_matched',
  UNMATCHED = 'unmatched',
  ERROR = 'error',
  ALL = 'all',
}

export enum ColumnMatchingStatus {
  MATCHED = 'matched',
  UNMATCHED = 'unmatched',
  ERROR = 'error',
  SYSTEM_MATCHED = 'system_matched',
  GROUP = 'group',
}

export enum ColumnKey {
  Unmatched = 'unmatched',
  AdminId = 'adminID',
  SubmissionDate = 'submissionDate',
  AccessType = 'accessType',
  SubmissionType = 'submissionType',
  EntityType = 'entityType',
  OrganizationName = 'organizationName',
  FullName = 'fullName',
  FirstName = 'firstName',
  LastName = 'lastName',
  Address = 'address',
  Address2 = 'address2',
  City = 'city',
  State = 'state',
  Country = 'country',
  Zip = 'zip',
  ContactEmail = 'contactEmail',
  PaymentEmail = 'paymentEmail',
  ContactPhone = 'contactPhone',
  PaymentPhone = 'paymentPhone',
  IpAddress = 'ipAddress',
  Referrer = 'referrer',
  IsOnlineSubmission = 'isOnlineSubmission',
  DocumentationProvided = 'documentationProvided',
  ClassMemberId = 'classMemberID',
  AuthenticationPin = 'authenticationPin',
  PassesCaseSpecificValidation = 'passesCaseSpecificValidation',
}

export enum FileUploadView {
  UPLOAD = 'upload',
  MATCH_COLUMNS = 'match_columns',
  UPLOADING = 'uploading',
  SUCCESS = 'success',
}

export type RecalculateResponse = {
  recalculated: boolean;
  error: string | null;
};

export interface RequiredColumnGroup {
  groupKey: string;
  keys: ColumnKey[];
  required: boolean;
  recommended: boolean;
  label: string;
}
